import { render, staticRenderFns } from "./trangchu3.vue?vue&type=template&id=556cb1da&"
import script from "./trangchu3.vue?vue&type=script&lang=js&"
export * from "./trangchu3.vue?vue&type=script&lang=js&"
import style0 from "./trangchu3.vue?vue&type=style&index=0&id=556cb1da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports